import { render, staticRenderFns } from "./_tabProducts.vue?vue&type=template&id=a2fa18ce&"
import script from "./_tabProducts.vue?vue&type=script&lang=js&"
export * from "./_tabProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports